<h2 mat-dialog-title>{{ 'DIALOG.ERROR' | translate }}</h2>
<mat-dialog-content>{{ data.error.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    color="accent"
    mat-flat-button
    mat-dialog-close>
    {{ data.error.okLabel || 'DIALOG.OK' | translate }}
  </button>
  <button
    color="primary"
    class="error-dialog-button-retry"
    *ngIf="data.error.shouldRetryOnFailure"
    mat-flat-button
    [mat-dialog-close]="true">
    {{ data.error.retryLabel || 'DIALOG.RETRY' | translate }}
  </button>
</mat-dialog-actions>
